// Event Hub Configuration
import { EventHubTracker } from './event-tracker';

// في التطوير: البروكسي يمرر /api إلى الباكند
// في الإنتاج: دائماً نطاق الباكند — بروكسي /api على نطاق الواجهة (مثل teen-sa.com) قد يعيد 403 من WAF
// والطلب يستخدم credentials: 'omit' فيتفق مع CORS AllowOrigins: "*" على الباكند
function trackingApiOrigin(): string {
  if (import.meta.env.DEV) return '';
  return (import.meta.env.VITE_BACKEND_URL || 'https://app.teen-sa.com').replace(/\/$/, '');
}

export const EVENT_HUB_CONFIG = {
  // Event Hub endpoint - استخدام proxy دائماً لضمان HMAC signature
  endpoint: `${trackingApiOrigin()}/api/events/track`, // Using the Backend Bridge dynamically
  
  // Platform Control - تفعيل جميع المنصات
  platformFlags: {
    meta: true,        // Facebook/Meta CAPI
    ga4: true,         // Google Analytics 4
    google_ads: true,  // Google Ads
    snapchat: true,    // Snapchat CAPI
    tiktok: true,      // TikTok Events API
    mixpanel: true,    // Mixpanel
    jitsu: true,       // Jitsu
    extra: false       // Extra webhooks
  },
  
  // Data Collection Settings
  enableEnhancedData: true,      // جمع بيانات الجهاز والمتصفح
  enableAutoPageTracking: false, // معطل - نستخدم manual tracking في _app.js
  enableAutoClickTracking: false, // تتبع النقرات (معطل لتجنب الإزعاج)
  enableAutoFormTracking: false,  // تتبع النماذج (معطل لتجنب الإزعاج)
  
  // Default Values for Multi-Country Support
  defaultCountry: 'SA', // السعودية كافتراضي
  defaultCurrency: 'SAR',
  defaultTimezone: 'Asia/Riyadh',
  
  // Privacy & Consent - معطل للسوق الشرق أوسطي
  respectDNT: false,             // تعطيل احترام Do Not Track
  enableConsentMode: false,      // تعطيل نظام الموافقة
  consentDefaults: undefined,    // لا موافقات افتراضية
  
  // Debug & Development
  debug: import.meta.env.DEV, // تفعيل التصحيح في التطوير فقط
  testMode: false, // تعطيل وضع الاختبار (لا نريد إرسال test_event_code)
  testEventCode: undefined   // بدون رمز اختبار
};

export const eventHub = new EventHubTracker(EVENT_HUB_CONFIG);

// ✅ إضافة eventHub إلى window للوصول إليه من Console
// متاح دائماً للاختبار والتطوير
if (typeof window !== 'undefined') {
  (window as any).eventHub = eventHub;
}
